import { getFetcher } from '@/lib/axios';

export const swrConfigValue = {
  fetcher: getFetcher,
  provider: () => new Map(),
};
